import { Routes } from '@angular/router';

import { CMS_PERMISSIONS } from '../../core/constants/permissions';
import { permissionGuard } from '../../core/guards/permission.guard';

export const enclaveRoutes: Routes = [
  {
    path: 'enclaves',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.enclaves.viewAny,
    },
    loadComponent: () => import('./pages/list/list').then((m) => m.EnclavesList),
  },
  {
    path: 'enclaves/crear',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.enclaves.create,
    },
    loadComponent: () => import('./pages/form/form').then((m) => m.EnclavesForm),
  },
  {
    path: 'enclaves/:id/editar',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.enclaves.update,
    },
    loadComponent: () => import('./pages/form/form').then((m) => m.EnclavesForm),
  },
];
